// extracted by mini-css-extract-plugin
module.exports = {"root":"LayoutSettings_root__1Y_S-","content":"LayoutSettings_content__11Oc_"};